// Generated by purs version 0.13.0
"use strict";
var Ritoppu_Model_Level = require("../Ritoppu.Model.Level/index.js");
var levelIncrease = function (xp) {
    return function (v) {
        return {
            currentLevel: v.currentLevel + 1 | 0,
            currentXp: (v.currentXp + xp | 0) - Ritoppu_Model_Level.experienceToNextLevel(v) | 0
        };
    };
};
module.exports = {
    levelIncrease: levelIncrease
};
